// for now it is not in use
import React, { Component } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import DropDownTable from '../../Shared/DropDownTable';
import UploadFile from '../../Shared/UploadFile';
import Input from '../../Shared/Input';
import '../../../css/MarketPlace/CreateServiceRequest.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import uparrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import calender from '../../../Assets/ProfileManagement/Assets-Desktop/calender.svg';
import SuccessModal from '../../Shared/SuccessModal';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL } from '../../../Services/config/apiGateway';
import { ALLANNOUNCEMENTS_ENDPOINT } from '../../../Services/config/apiEndPoints';

class CreateServiceRequest extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            headerServiceName: '',
            PickupLocation: '',
            Destination: '',
            ServiceWindowStartValue: new Date(),
            showServiceWindowStartCalendar: false,
            ServiceWindowStartDate: '',
            SWStartHour: '',
            SWStartHourdropdown: false,
            SWStartHourdata: [],
            SWStartMinit: '',
            SWStartMinitdropdown: false,
            SWStartMinitdata: [],
            ServiceWindowEndValue: new Date(),
            showServiceWindowEndCalendar: false,
            ServiceWindowEndDate: '',
            SWEndHour: '',
            SWEndHourdropdown: false,
            SWEndHourdata: [],
            SWEndMinit: '',
            SWEndMinitdropdown: false,
            SWEndMinitdata: [],
            RFQClosingValue: new Date(),
            showRFQClosingCalendar: false,
            RFQClosingDate: '',
            NoofContainers: '',
            SpecialInstructions: '',
            SpecialInstructionstextLimit: 0,
            Commodity: '',
            Commoditydropdown: false,
            Commoditydata: [],
            TruckTypeRequirements: '',
            TruckTypeRequirementsdropdown: false,
            TruckTypeRequirementsdata: [],
            PaymentTerms: '',
            PaymentTermsdropdown: false,
            PaymentTermsdata: [],
            loaderTime: false,
            PageDisable: false,
            FilePathUpdateReferenceDocuments: '',
            errors: {},
            hasOpenSuccess: false
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    Commoditydata = [{ name: "Bulk Bags" }, { name: "Bulk Cargo" }, { name: "Bundled Steel/Timber" }]
    SWStartHourdata = [{ hour: "00" }, { hour: "01" }, { hour: "02" }, { hour: "03" }, { hour: "04" }, { hour: "05" }, { hour: "06" }, { hour: "07" }, { hour: "08" }, { hour: "09" },
    { hour: "10" }, { hour: "11" }, { hour: "12" }, { hour: "13" }, { hour: "14" }, { hour: "15" }, { hour: "16" }, { hour: "17" }, { hour: "18" }, { hour: "19" },
    { hour: "20" }, { hour: "21" }, { hour: "22" }, { hour: "23" }]
    SWEndHourdata = [{ hour: "00" }, { hour: "01" }, { hour: "02" }, { hour: "03" }, { hour: "04" }, { hour: "05" }, { hour: "06" }, { hour: "07" }, { hour: "08" }, { hour: "09" },
    { hour: "10" }, { hour: "11" }, { hour: "12" }, { hour: "13" }, { hour: "14" }, { hour: "15" }, { hour: "16" }, { hour: "17" }, { hour: "18" }, { hour: "19" },
    { hour: "20" }, { hour: "21" }, { hour: "22" }, { hour: "23" }]
    SWStartMinitdata = [{ minit: "00" }, { minit: "01" }, { minit: "02" }, { minit: "03" }, { minit: "04" }, { minit: "05" }, { hour: "06" }, { hour: "07" }, { minit: "08" }, { minit: "09" },
    { minit: "10" }, { minit: "11" }, { minit: "12" }, { minit: "13" }, { minit: "14" }, { minit: "15" }, { minit: "16" }, { minit: "17" }, { minit: "18" }, { minit: "19" },
    { minit: "20" }, { minit: "21" }, { minit: "22" }, { minit: "23" }, { minit: "24" }, { minit: "25" }, { minit: "26" }, { minit: "27" }, { minit: "28" }, { minit: "29" },
    { minit: "30" }, { minit: "31" }, { minit: "32" }, { minit: "33" }, { minit: "34" }, { minit: "35" }, { minit: "36" }, { minit: "37" }, { minit: "38" }, { minit: "39" },
    { minit: "40" }, { minit: "41" }, { minit: "42" }, { minit: "43" }, { minit: "44" }, { minit: "45" }, { minit: "46" }, { minit: "47" }, { minit: "48" }, { minit: "49" },
    { minit: "50" }, { minit: "51" }, { minit: "52" }, { minit: "53" }, { minit: "54" }, { minit: "55" }, { minit: "56" }, { minit: "57" }, { minit: "58" }, { minit: "59" },]
    SWEndMinitdata = [{ minit: "00" }, { minit: "01" }, { minit: "02" }, { minit: "03" }, { minit: "04" }, { minit: "05" }, { hour: "06" }, { hour: "07" }, { minit: "08" }, { minit: "09" },
    { minit: "10" }, { minit: "11" }, { minit: "12" }, { minit: "13" }, { minit: "14" }, { minit: "15" }, { minit: "16" }, { minit: "17" }, { minit: "18" }, { minit: "19" },
    { minit: "20" }, { minit: "21" }, { minit: "22" }, { minit: "23" }, { minit: "24" }, { minit: "25" }, { minit: "26" }, { minit: "27" }, { minit: "28" }, { minit: "29" },
    { minit: "30" }, { minit: "31" }, { minit: "32" }, { minit: "33" }, { minit: "34" }, { minit: "35" }, { minit: "36" }, { minit: "37" }, { minit: "38" }, { minit: "39" },
    { minit: "40" }, { minit: "41" }, { minit: "42" }, { minit: "43" }, { minit: "44" }, { minit: "45" }, { minit: "46" }, { minit: "47" }, { minit: "48" }, { minit: "49" },
    { minit: "50" }, { minit: "51" }, { minit: "52" }, { minit: "53" }, { minit: "54" }, { minit: "55" }, { minit: "56" }, { minit: "57" }, { minit: "58" }, { minit: "59" },]
    TruckTypeRequirementsdata = [{ name: "Bulk Bags" }, { name: "Bulk Cargo" }, { name: "Bundled Steel/Timber" }]
    PaymentTermsdata = [{ name: "Bulk Bags" }, { name: "Bulk Cargo" }, { name: "Bundled Steel/Timber" }]
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        const { serviceName } = this.props.match.params;
        this.setState({ headerServiceName: serviceName });
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ Commoditydropdown: false });
            this.setState({ SWStartHourdropdown: false });
            this.setState({ SWEndHourdropdown: false });
            this.setState({ SWStartMinitdropdown: false });
            this.setState({ SWEndMinitdropdown: false });
            this.setState({ TruckTypeRequirementsdropdown: false });
            this.setState({ PaymentTermsdropdown: false });
            this.setState({ showServiceWindowStartCalendar: false });
            this.setState({ showServiceWindowEndCalendar: false });
            this.setState({ showRFQClosingCalendar: false });
        }
    };
    handleChangePickupLocation = (e) => {
        this.setState({ PickupLocation: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                PickupLocation: ''
            }
        });
        document.getElementsByName('PickupLocation')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeDestination = (e) => {
        this.setState({ Destination: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                Destination: ''
            }
        });
        document.getElementsByName('Destination')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeNoofContainers = (e) => {
        this.setState({ NoofContainers: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                NoofContainers: ''
            }
        });
        document.getElementsByName('NoofContainers')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeSpecialInstructions = (e) => {
        if (e.target.value.length <= 180) {
            this.setState({ SpecialInstructionstextLimit: e.target.value.length });
            this.setState({ SpecialInstructions: e.target.value });
            this.setState({
                errors: {
                    ...this.state.errors,
                    SpecialInstructions: ''
                }
            });
            document.getElementsByName('SpecialInstructions')[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    toggleDropdownCommodity = () => {
        this.setState({ Commoditydropdown: !this.state.Commoditydropdown });
    };
    changeRoleTypeCommodity = (event) => {
        const found = this.Commoditydata.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ Commodity: found.name });
        this.setState({ Commoditydropdown: !this.state.Commoditydropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                Commodity: ''
            }
        });
        document.getElementsByName('Commodity')[0].style.borderColor = ColorCode.colorCode.black;
    }
    toggleDropdownSWStartHour = () => {
        this.setState({ SWStartHourdropdown: !this.state.SWStartHourdropdown });
    };
    changeRoleTypeSWStartHour = (event) => {
        const found = this.SWStartHourdata.find((name) => {
            if (name.hour === event.target.innerText) {
                return name
            }
        })
        this.setState({ SWStartHour: found.hour, SWStartHourdropdown: !this.state.SWStartHourdropdown });
        if (this.state.ServiceWindowStartDate && this.state.SWStartMinit) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    ServiceWindowStartDate: ''
                }
            });
        }
        if (this.state.SWStartMinit) {
            document.getElementsByName('SWStartHourMinit')[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    toggleDropdownSWStartMinit = () => {
        this.setState({ SWStartMinitdropdown: !this.state.SWStartMinitdropdown });
    };
    changeRoleTypeSWStartMinit = (event) => {
        const found = this.SWStartMinitdata.find((name) => {
            if (name.minit === event.target.innerText) {
                return name
            }
        })
        this.setState({ SWStartMinit: found.minit, SWStartMinitdropdown: !this.state.SWStartMinitdropdown });
        if (this.state.ServiceWindowStartDate && this.state.SWStartHour) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    ServiceWindowStartDate: ''
                }
            });
        }
        if (this.state.SWStartHour) {
            document.getElementsByName('SWStartHourMinit')[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    toggleDropdownSWEndHour = () => {
        this.setState({ SWEndHourdropdown: !this.state.SWEndHourdropdown });
    };
    changeRoleTypeSWEndHour = (event) => {
        const found = this.SWEndHourdata.find((name) => {
            if (name.hour === event.target.innerText) {
                return name
            }
        })
        this.setState({ SWEndHour: found.hour, SWEndHourdropdown: !this.state.SWEndHourdropdown });
        if (this.state.ServiceWindowEndDate && this.state.SWEndMinit) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    ServiceWindowEndDate: ''
                }
            });
        }
        if (this.state.SWEndMinit) {
            document.getElementsByName('SWEndHourMinit')[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    toggleDropdownSWEndMinit = () => {
        this.setState({ SWEndMinitdropdown: !this.state.SWEndMinitdropdown });
    };
    changeRoleTypeSWEndMinit = (event) => {
        const found = this.SWEndMinitdata.find((name) => {
            if (name.minit === event.target.innerText) {
                return name
            }
        })
        this.setState({ SWEndMinit: found.minit, SWEndMinitdropdown: !this.state.SWEndMinitdropdown });
        if (this.state.ServiceWindowEndDate && this.state.SWEndHour) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    ServiceWindowEndDate: ''
                }
            });
        }
        if (this.state.SWEndHour) {
            document.getElementsByName('SWEndHourMinit')[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    toggleDropdownTruckTypeRequirements = () => {
        this.setState({ TruckTypeRequirementsdropdown: !this.state.TruckTypeRequirementsdropdown });
    };
    changeRoleTypeTruckTypeRequirements = (event) => {
        const found = this.TruckTypeRequirementsdata.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ TruckTypeRequirements: found.name });
        this.setState({ TruckTypeRequirementsdropdown: !this.state.TruckTypeRequirementsdropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                TruckTypeRequirements: ''
            }
        });
        document.getElementsByName('TruckTypeRequirements')[0].style.borderColor = ColorCode.colorCode.black;
    }
    toggleDropdownPaymentTerms = () => {
        this.setState({ PaymentTermsdropdown: !this.state.PaymentTermsdropdown });
    };
    changeRoleTypePaymentTerms = (event) => {
        const found = this.PaymentTermsdata.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ PaymentTerms: found.name });
        this.setState({ PaymentTermsdropdown: !this.state.PaymentTermsdropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                PaymentTerms: ''
            }
        });
        document.getElementsByName('PaymentTerms')[0].style.borderColor = ColorCode.colorCode.black;
    }
    getDateFormated = (timeStamp) => {
        let date = new Date(Number(timeStamp)).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    handleServiceWindowStartChanged = (e) => {
        this.setState({
            ServiceWindowStartValue: e,
            ServiceWindowStartDate: this.getDateFormated(e),
            showServiceWindowStartCalendar: !this.state.showServiceWindowStartCalendar,
        })
        if (this.state.SWStartMinit && this.state.SWStartHour) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    ServiceWindowStartDate: ''
                }
            });
        }
        document.getElementsByName('ServiceWindowStartDate')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeServiceWindowStartDate = (e) => {
        this.setState({
            ServiceWindowStartDate: e.target.value,
        })
        this.setState({
            errors: {
                ...this.state.errors,
                ServiceWindowStartDate: ''
            }
        });
        document.getElementsByName('ServiceWindowStartDate')[0].style.borderColor = ColorCode.colorCode.black;
    }
    toggleServiceWindowStartCalendar = () => {
        this.setState({ showServiceWindowStartCalendar: !this.state.showServiceWindowStartCalendar })
    }
    handleServiceWindowEndChanged = (e) => {
        this.setState({
            ServiceWindowEndValue: e,
            ServiceWindowEndDate: this.getDateFormated(e),
            showServiceWindowEndCalendar: !this.state.showServiceWindowEndCalendar,
        })
        if (this.state.SWEndMinit && this.state.SWEndHour) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    ServiceWindowEndDate: ''
                }
            });
        }
        document.getElementsByName('ServiceWindowEndDate')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeServiceWindowEndDate = (e) => {
        this.setState({
            ServiceWindowEndDate: e.target.value,
        })
        this.setState({
            errors: {
                ...this.state.errors,
                ServiceWindowEndDate: ''
            }
        });
        document.getElementsByName('ServiceWindowEndDate')[0].style.borderColor = ColorCode.colorCode.black;
    }
    toggleServiceWindowEndCalendar = () => {
        this.setState({ showServiceWindowEndCalendar: !this.state.showServiceWindowEndCalendar })
    }
    handleRFQClosingChanged = (e) => {
        this.setState({
            RFQClosingValue: e,
            RFQClosingDate: this.getDateFormated(e),
            showRFQClosingCalendar: !this.state.showRFQClosingCalendar,
        })
    }
    handleChangeRFQClosingDate = (e) => {
        this.setState({
            RFQClosingDate: e.target.value,
        })
    }
    toggleRFQClosingCalendar = () => {
        this.setState({ showRFQClosingCalendar: !this.state.showRFQClosingCalendar })
    }
    uploadFileFunction = (uploadConfirm) => {
    }
    removeUpdateReferenceDocumentsLink = () => {
        let path = "";
        this.setState({ FilePathUpdateReferenceDocuments: path });
    }
    setLoaderUpdateReferenceDocuments = (filePathURL) => {
        this.setState({ loaderTime: filePathURL });
        this.setState({ PageDisable: filePathURL });
    }
    setUploadLinkUpdateReferenceDocuments = (filePathURL) => {
        // for loader end
        this.setState({ FilePathUpdateReferenceDocuments: filePathURL });
        this.setState({ loaderTime: false });
        this.setState({ PageDisable: false });
    }
    onCloseModal = () => {
        this.setState({ hasOpenSuccess: false });
        this.props.history.push('/ServiceSelection');
    };
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        var patternDigit = new RegExp(/^[0-9\b]+$/);
        if (!this.state.PickupLocation) {
            formIsValid = false;
            errors["PickupLocation"] = Message.validation.required;
            document.getElementsByName('PickupLocation')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('PickupLocation')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.Destination) {
            formIsValid = false;
            errors["Destination"] = Message.validation.required;
            document.getElementsByName('Destination')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('Destination')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.NoofContainers) {
            formIsValid = false;
            errors["NoofContainers"] = Message.validation.required;
            document.getElementsByName('NoofContainers')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else if (!patternDigit.test(this.state.NoofContainers)) {
            formIsValid = false;
            errors["NoofContainers"] = Message.validation.num;
            document.getElementsByName('NoofContainers')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else {
            document.getElementsByName('NoofContainers')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.Commodity) {
            formIsValid = false;
            errors["Commodity"] = Message.validation.required;
            document.getElementsByName('Commodity')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('Commodity')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.SWStartHour) {
            formIsValid = false;
            errors["ServiceWindowStartDate"] = Message.validation.required;
            document.getElementsByName('SWStartHourMinit')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('SWStartHourMinit')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.SWStartMinit) {
            formIsValid = false;
            errors["ServiceWindowStartDate"] = Message.validation.required;
            document.getElementsByName('SWStartHourMinit')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('SWStartHourMinit')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.SWEndHour) {
            formIsValid = false;
            errors["ServiceWindowEndDate"] = Message.validation.required;
            document.getElementsByName('SWEndHourMinit')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('SWEndHourMinit')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.SWEndMinit) {
            formIsValid = false;
            errors["ServiceWindowEndDate"] = Message.validation.required;
            document.getElementsByName('SWEndHourMinit')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('SWEndHourMinit')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.TruckTypeRequirements) {
            formIsValid = false;
            errors["TruckTypeRequirements"] = Message.validation.required;
            document.getElementsByName('TruckTypeRequirements')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('TruckTypeRequirements')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.PaymentTerms) {
            formIsValid = false;
            errors["PaymentTerms"] = Message.validation.required;
            document.getElementsByName('PaymentTerms')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('PaymentTerms')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.ServiceWindowStartDate) {
            formIsValid = false;
            errors["ServiceWindowStartDate"] = Message.validation.required;
            document.getElementsByName('ServiceWindowStartDate')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('ServiceWindowStartDate')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.ServiceWindowEndDate) {
            formIsValid = false;
            errors["ServiceWindowEndDate"] = Message.validation.required;
            document.getElementsByName('ServiceWindowEndDate')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('ServiceWindowEndDate')[0].style.borderColor = ColorCode.colorCode.black;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleSubmitRequest = () => {
        if (this.handleValidation()) {
            ApiCall(
                'POST',
                serviceBaseURL + ALLANNOUNCEMENTS_ENDPOINT,
                {
                    "requestData": {
                        "baseService": {
                            "serviceType": this.state.headerServiceName,
                            "startDateTime": "ddmmyyyyhhmmss",
                            "status": "In Progress, Completed",
                            "requestorCompanyName": "XYZ company",
                            "location": "Durban",
                            "publishDateTime": "ddmmyyyyhhmmss",
                            "endDateTime": "ddmmyyyyhhmmss",
                            "rfqDateTime": "ddmmyyyyhhmmss"
                        },
                        "fieldsData": "CDATA[json data]",
                        "docPath": "/server/docPath"
                    }
                },
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            ).then(data => {
                if (data.flag != -1) {
                    if (data.flag == '500') {
                        console.log('I am 500!');
                    } else {
                        console.log('I am 200!');
                        this.setState({ hasOpenSuccess: true });
                    }
                }
                else {
                    console.log('Something went wrong!');
                }
            });
        }
    }
    render() {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let ServiceWindowStart_date = this.state.ServiceWindowStartValue.getDate() + "-" + months[this.state.ServiceWindowStartValue.getMonth()] + "-" + this.state.ServiceWindowStartValue.getFullYear();
        if (this.state.ServiceWindowStartValue.getDate() <= 9) {
            ServiceWindowStart_date = "0" + this.state.ServiceWindowStartValue.getDate() + "-" + months[this.state.ServiceWindowStartValue.getMonth()] + "-" + this.state.ServiceWindowStartValue.getFullYear();
        }
        let ServiceWindowEnd_date = this.state.ServiceWindowEndValue.getDate() + "-" + months[this.state.ServiceWindowEndValue.getMonth()] + "-" + this.state.ServiceWindowEndValue.getFullYear();
        if (this.state.ServiceWindowEndValue.getDate() <= 9) {
            ServiceWindowEnd_date = "0" + this.state.ServiceWindowEndValue.getDate() + "-" + months[this.state.ServiceWindowEndValue.getMonth()] + "-" + this.state.ServiceWindowEndValue.getFullYear();
        }
        let RFQClosing_date = this.state.RFQClosingValue.getDate() + "-" + months[this.state.RFQClosingValue.getMonth()] + "-" + this.state.RFQClosingValue.getFullYear();
        if (this.state.RFQClosingValue.getDate() <= 9) {
            RFQClosing_date = "0" + this.state.RFQClosingValue.getDate() + "-" + months[this.state.RFQClosingValue.getMonth()] + "-" + this.state.RFQClosingValue.getFullYear();
        }
        return (
            <div class="TransportServiceOutercolor">
                <MetaDecorator title={TitleDescription.CreateServiceRequestTitle} description={TitleDescription.CreateServiceRequestDescription} />
                <Header tilesFetched={() => { }} />
                <div class="TransportServiceOuterDivcss">
                    <div id="TransportServiceBoxDiv">
                        <nav class="TransportServiceNavbar">
                            <div className="TransportServiceNavbarName">
                                <small id="TransportServiceNavbarText">{this.state.headerServiceName}</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="TransportServiceMidPartition">
                            <div class="TransportServiceHeadingText">Service Request Details</div>
                            <div class="TransportServiceCardcss">
                                <div class="TransportServiceInpSize">
                                    <small id="TransportServiceInpHeading">Pickup Location</small>
                                    <div className="pass-wrapper" id="TransportServiceInpDiv" >
                                        <Input
                                            name="PickupLocation"
                                            class="input" placeholder="Enter Pickup Location"
                                            type="text" id="TransportServiceInpCss" value={this.state.PickupLocation}
                                            onChange={this.handleChangePickupLocation}
                                        />
                                        <div className="TransportServiceError">{this.state.errors["PickupLocation"]}</div>
                                    </div>
                                </div>
                                <div class="TransportServiceInpSize">
                                    <small id="TransportServiceInpHeading">Destination</small>
                                    <div className="pass-wrapper" id="TransportServiceInpDiv" >
                                        <Input
                                            name="Destination"
                                            class="input" placeholder="Enter Destination"
                                            type="text" id="TransportServiceInpCss" value={this.state.Destination}
                                            onChange={this.handleChangeDestination}
                                        />
                                        <div className="TransportServiceError">{this.state.errors["Destination"]}</div>
                                    </div>
                                </div>
                                <div class="TransportServiceInpSize">
                                    <small id="TransportServiceInpHeading">Service Window Start Date & Time</small>
                                    <div id="TransportServiceCalOuterDiv">
                                        <div className="pass-wrapper" id="TransportServiceCalendarDiv">
                                            <input
                                                readOnly
                                                class="inpuut1"
                                                placeholder="Select Date"
                                                type="text"
                                                id="TransportServiceCalSWCss"
                                                name="ServiceWindowStartDate"
                                                autoComplete="off"
                                                value={this.state.showServiceWindowStartCalendar ? ServiceWindowStart_date : this.state.ServiceWindowStartDate}
                                                onChange={this.handleChangeServiceWindowStartDate} />
                                            <div className="TransportServiceDropError">{this.state.errors["ServiceWindowStartDate"]}</div>
                                            <div class="TransportServiceSWCalendarWidth">  {this.state.showServiceWindowStartCalendar ?
                                                <div ref={this.container}>
                                                    <Calendar onChange={this.handleServiceWindowStartChanged} value={this.state.ServiceWindowStartValue} />
                                                </div> : null}
                                            </div>
                                            <img id="TransportServiceSWCal_imgCal" src={calender} alt="" onClick={this.toggleServiceWindowStartCalendar}
                                            />
                                        </div>
                                        <div id={this.state.SWStartHourdropdown ? "TransportServiceHourDiv" : (this.state.SWStartMinitdropdown ? "TransportServiceMinitDiv" : "TransportServiceHTDiv")} name="SWStartHourMinit">
                                            <div id="TransportServiceHHDiv" >
                                                <div className="pass-wrapper" id="TransportServiceInpDiv" >
                                                    <Input
                                                        readOnly name="SWStartHour" class="" placeholder="HH"
                                                        type="text" id="TransportServiceHTDropCss" value={this.state.SWStartHour}
                                                    />
                                                    <div className="TransportServiceDropError">{this.state.errors["SWStartHour"]}</div>
                                                    <i id="TransportServiceHHMM_imgDrop" onClick={this.toggleDropdownSWStartHour}>
                                                        {this.state.SWStartHourdropdown ? <img src={uparrow} /> : <img src={downarrow} />}
                                                    </i>
                                                </div>
                                                {this.state.SWStartHourdropdown && (
                                                    <div class="TransportServiceDropDowmDiv" >
                                                        <div class="TransportServiceHMDropCard" ref={this.container} >
                                                            {(this.SWStartHourdata.map((name, index) => {
                                                                return (
                                                                    <DropDownTable onClick={(val) => this.changeRoleTypeSWStartHour(val)} id="TransportServiceHHMMRowSize">
                                                                        <small class="" id="TransportServiceDropRowText" >{name.hour} </small>
                                                                    </DropDownTable>
                                                                );
                                                            }))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div id="TransportServiceTTDiv">
                                                <div className="pass-wrapper" id="TransportServiceInpDiv" >
                                                    <Input
                                                        readOnly name="SWStartMinit" class="" placeholder="MM"
                                                        type="text" id="TransportServiceHTDropCss" value={this.state.SWStartMinit}
                                                    />
                                                    <div className="TransportServiceDropError">{this.state.errors["SWStartMinit"]}</div>
                                                    <i id="TransportServiceMinit_imgDrop" onClick={this.toggleDropdownSWStartMinit}>
                                                        {this.state.SWStartMinitdropdown ? <img src={uparrow} /> : <img src={downarrow} />}
                                                    </i>
                                                </div>
                                                {this.state.SWStartMinitdropdown && (
                                                    <div class="TransportServiceDropDowmDiv" >
                                                        <div class="TransportServiceHMDropCard" ref={this.container} >
                                                            {(this.SWStartMinitdata.map((name, index) => {
                                                                return (
                                                                    <DropDownTable onClick={(val) => this.changeRoleTypeSWStartMinit(val)} id="TransportServiceHHMMRowSize">
                                                                        <small class="" id="TransportServiceDropRowText" >{name.minit} </small>
                                                                    </DropDownTable>
                                                                );
                                                            }))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="TransportServiceInpSize">
                                    <small id="TransportServiceInpHeading">Service Window End Date & Time</small>
                                    <div id="TransportServiceCalOuterDiv">
                                        <div className="pass-wrapper" id="TransportServiceCalendarDiv">
                                            <input
                                                readOnly
                                                class="inpuut1"
                                                placeholder="Select Date"
                                                type="text"
                                                id="TransportServiceCalSWCss"
                                                name="ServiceWindowEndDate"
                                                autoComplete="off"
                                                value={this.state.showServiceWindowEndCalendar ? ServiceWindowEnd_date : this.state.ServiceWindowEndDate}
                                                onChange={this.handleChangeServiceWindowEndDate} />
                                            <div className="TransportServiceDropError">{this.state.errors["ServiceWindowEndDate"]}</div>
                                            <div class="TransportServiceSWCalendarWidth">  {this.state.showServiceWindowEndCalendar ?
                                                <div ref={this.container}>
                                                    <Calendar onChange={this.handleServiceWindowEndChanged} value={this.state.ServiceWindowEndValue} />
                                                </div> : null}
                                            </div>
                                            <img id="TransportServiceSWCal_imgCal" src={calender} alt="" onClick={this.toggleServiceWindowEndCalendar}
                                            />
                                        </div>
                                        <div id={this.state.SWEndHourdropdown ? "TransportServiceHourDiv" : (this.state.SWEndMinitdropdown ? "TransportServiceMinitDiv" : "TransportServiceHTDiv")} name="SWEndHourMinit">
                                            <div id="TransportServiceHHDiv" >
                                                <div className="pass-wrapper" id="TransportServiceInpDiv" >
                                                    <Input
                                                        readOnly name="SWEndHour" class="" placeholder="HH"
                                                        type="text" id="TransportServiceHTDropCss" value={this.state.SWEndHour}
                                                    />
                                                    <div className="TransportServiceDropError">{this.state.errors["SWEndHour"]}</div>
                                                    <i id="TransportServiceHHMM_imgDrop" onClick={this.toggleDropdownSWEndHour}>
                                                        {this.state.SWEndHourdropdown ? <img src={uparrow} /> : <img src={downarrow} />}
                                                    </i>
                                                </div>
                                                {this.state.SWEndHourdropdown && (
                                                    <div class="TransportServiceDropDowmDiv" >
                                                        <div class="TransportServiceHMDropCard" ref={this.container} >
                                                            {(this.SWEndHourdata.map((name, index) => {
                                                                return (
                                                                    <DropDownTable onClick={(val) => this.changeRoleTypeSWEndHour(val)} id="TransportServiceHHMMRowSize">
                                                                        <small class="" id="TransportServiceDropRowText" >{name.hour} </small>
                                                                    </DropDownTable>
                                                                );
                                                            }))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div id="TransportServiceTTDiv">
                                                <div className="pass-wrapper" id="TransportServiceInpDiv" >
                                                    <Input
                                                        readOnly name="SWEndMinit" class="" placeholder="MM"
                                                        type="text" id="TransportServiceHTDropCss" value={this.state.SWEndMinit}
                                                    />
                                                    <div className="TransportServiceDropError">{this.state.errors["SWEndMinit"]}</div>
                                                    <i id="TransportServiceMinit_imgDrop" onClick={this.toggleDropdownSWEndMinit}>
                                                        {this.state.SWEndMinitdropdown ? <img src={uparrow} /> : <img src={downarrow} />}
                                                    </i>
                                                </div>
                                                {this.state.SWEndMinitdropdown && (
                                                    <div class="TransportServiceDropDowmDiv" >
                                                        <div class="TransportServiceHMDropCard" ref={this.container} >
                                                            {(this.SWEndMinitdata.map((name, index) => {
                                                                return (
                                                                    <DropDownTable onClick={(val) => this.changeRoleTypeSWEndMinit(val)} id="TransportServiceHHMMRowSize">
                                                                        <small class="" id="TransportServiceDropRowText" >{name.minit} </small>
                                                                    </DropDownTable>
                                                                );
                                                            }))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="TransportServiceInpSize">
                                    <small id="TransportServiceInpHeading">No. of Containers</small>
                                    <div className="pass-wrapper" id="TransportServiceInpDiv" >
                                        <Input
                                            name="NoofContainers"
                                            class="input" placeholder="Enter No."
                                            type="text" id="TransportServiceInpCss" value={this.state.NoofContainers}
                                            onChange={this.handleChangeNoofContainers}
                                        />
                                        <div className="TransportServiceError">{this.state.errors["NoofContainers"]}</div>
                                    </div>
                                </div>
                                <div class="TransportServiceInpSize">
                                    <small id="TransportServiceInpHeading">Commodity</small>
                                    <div className="pass-wrapper" id="TransportServiceInpDiv" >
                                        <Input
                                            readOnly name="Commodity" class="input" placeholder="Select Commodity"
                                            type="text" id={this.state.Commoditydropdown ? "TransportServiceBtmBorderLessCss" : "TransportServiceInpDropCss"} value={this.state.Commodity}
                                        />
                                        <div className="TransportServiceDropError">{this.state.errors["Commodity"]}</div>
                                        <i id="TransportServiceInp_imgDrop" onClick={this.toggleDropdownCommodity}>
                                            {this.state.Commoditydropdown ? <img src={uparrow} /> : <img src={downarrow} />}
                                        </i>
                                    </div>
                                    {this.state.Commoditydropdown && (
                                        <div class="TransportServiceDropDowmDiv" >
                                            <div class="TransportServiceDropCard" ref={this.container} >
                                                {(this.Commoditydata.map((name, index) => {
                                                    return (
                                                        <DropDownTable onClick={(val) => this.changeRoleTypeCommodity(val)} id="TransportServiceDropRowSize">
                                                            <small class="" id="TransportServiceDropRowText" >{name.name} </small>
                                                        </DropDownTable>
                                                    );
                                                }))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div class="TransportServiceInpSize">
                                    <small id="TransportServiceInpHeading">Truck Type Requirements</small>
                                    <div className="pass-wrapper" id="TransportServiceInpDiv" >
                                        <Input
                                            readOnly name="TruckTypeRequirements" class="input" placeholder="Select Truck Type Requirements"
                                            type="text" id={this.state.TruckTypeRequirementsdropdown ? "TransportServiceBtmBorderLessCss" : "TransportServiceInpDropCss"}
                                            value={this.state.TruckTypeRequirements}
                                        />
                                        <div className="TransportServiceDropError">{this.state.errors["TruckTypeRequirements"]}</div>
                                        <i id="TransportServiceInp_imgDrop" onClick={this.toggleDropdownTruckTypeRequirements}>
                                            {this.state.TruckTypeRequirementsdropdown ? <img src={uparrow} /> : <img src={downarrow} />}
                                        </i>
                                    </div>
                                    {this.state.TruckTypeRequirementsdropdown && (
                                        <div class="TransportServiceDropDowmDiv" >
                                            <div class="TransportServiceDropCard" ref={this.container} >
                                                {(this.TruckTypeRequirementsdata.map((name, index) => {
                                                    return (
                                                        <DropDownTable onClick={(val) => this.changeRoleTypeTruckTypeRequirements(val)} id="TransportServiceDropRowSize">
                                                            <small class="" id="TransportServiceDropRowText" >{name.name} </small>
                                                        </DropDownTable>
                                                    );
                                                }))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div class="TransportServiceInpSize">
                                    <small id="TransportServiceInpHeading">Payment Terms</small>
                                    <div className="pass-wrapper" id="TransportServiceInpDiv" >
                                        <Input
                                            readOnly name="PaymentTerms" class="input" placeholder="Select Payment Terms"
                                            type="text" id={this.state.PaymentTermsdropdown ? "TransportServiceBtmBorderLessCss" : "TransportServiceInpDropCss"}
                                            value={this.state.PaymentTerms}
                                        />
                                        <div className="TransportServiceDropError">{this.state.errors["PaymentTerms"]}</div>
                                        <i id="TransportServiceInp_imgDrop" onClick={this.toggleDropdownPaymentTerms}>
                                            {this.state.PaymentTermsdropdown ? <img src={uparrow} /> : <img src={downarrow} />}
                                        </i>
                                    </div>
                                    {this.state.PaymentTermsdropdown && (
                                        <div class="TransportServiceDropDowmDiv" >
                                            <div class="TransportServiceDropCard" ref={this.container} >
                                                {(this.PaymentTermsdata.map((name, index) => {
                                                    return (
                                                        <DropDownTable onClick={(val) => this.changeRoleTypePaymentTerms(val)} id="TransportServiceDropRowSize">
                                                            <small class="" id="TransportServiceDropRowText" >{name.name} </small>
                                                        </DropDownTable>
                                                    );
                                                }))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div class="TransportServiceInpSize">
                                    <small id="TransportServiceInpHeading">RFQ Closing Date (Optional)</small>
                                    <div className="pass-wrapper" id="TransportServiceInpDiv">
                                        <input
                                            readOnly
                                            class="inpuut1"
                                            placeholder="Select Date"
                                            type="text"
                                            id="TransportServiceInpCss"
                                            name="RFQClosingDate"
                                            autoComplete="off"
                                            value={this.state.showRFQClosingCalendar ? RFQClosing_date : this.state.RFQClosingDate}
                                            onChange={this.handleChangeRFQClosingDate} />
                                        <div class="TransportServiceCalendarWidth">  {this.state.showRFQClosingCalendar ?
                                            <div ref={this.container}>
                                                <Calendar onChange={this.handleRFQClosingChanged} value={this.state.RFQClosingValue} />
                                            </div> : null}
                                        </div>
                                        <img id="TransportServiceInp_imgCal" src={calender} alt="" onClick={this.toggleRFQClosingCalendar}
                                        />
                                    </div>
                                </div>
                                <div class="TransportServiceTextInpSize">
                                    <small id="TransportServiceInpHeading">Special Instructions (Optional)</small>
                                    <div className="pass-wrapper" id="TransportServiceInpDiv" >
                                        <Input
                                            name="SpecialInstructions"
                                            class="input" placeholder="Enter Special Requirements"
                                            type="text" id="TransportServiceInpCss" value={this.state.SpecialInstructions}
                                            onChange={this.handleChangeSpecialInstructions}
                                        />
                                        <div className="TransportServiceError">{this.state.errors["SpecialInstructions"]}</div>
                                        <small class="TransportServiceCommentTextlmt">{this.state.SpecialInstructionstextLimit}/180</small>
                                    </div>
                                </div>
                                <div class="TransportServiceInpSize">
                                    <small id="TransportServiceInpHeading">Update Reference Documents (Optional)</small>
                                    <div className="pass-wrapper" id="TransportServiceInpDiv" >
                                        <UploadFile uploaddivid="uploadUpdateReferenceDocuments" idupload="upload"
                                            name="fileupload"
                                            fileType="jpeg, jpg, png, pdf"
                                            setUploadConfirm={this.uploadFileFunction}
                                            removeLink={this.removeUpdateReferenceDocumentsLink}
                                            upload_link="cipcUpload" uploadicon="cipcIcon"
                                            setFileLink={this.setUploadLinkUpdateReferenceDocuments}
                                            setLoader={this.setLoaderUpdateReferenceDocuments}
                                            staticFileName={'Update_Reference_Documents.'}
                                        />
                                        {/* <div className="TransportServiceError">{this.state.errors["UpdateReferenceDocuments"]}</div> */}
                                    </div>
                                </div>
                            </div>
                            <div class="TransportServiceBtnDiv">
                                <Button class="TransportServiceBtnCss" onClick={this.handleSubmitRequest}>
                                    <small class="TransportServiceBtntext">Submit Request</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="TransportServiceFooterUnfixed">
                    <Footer />
                </div>
                <div class="TransportServiceFooterFixed">
                    <Footer2 />
                </div>
                <SuccessModal hasOpen={this.state.hasOpenSuccess} onCloseModal={this.onCloseModal}>
                    <div>
                        <div class="successRatingdivout">
                            <small class="successRatingdivsm">Your request has been submitted
 </small>
                            <small class="successRatingdivsm"> successfully.</small>
                        </div>
                    </div>
                </SuccessModal>
            </div >
        );
    }
}
export default CreateServiceRequest;